import { Component } from '@angular/core';

type Exchange = 'Binance' | 'Coinbase' | 'CoinDCX';
type Token = 'BTC' | 'ETH' | 'XRP';

@Component({
  selector: 'app-exchange-investment',
  templateUrl: './exchange-investment.component.html',
  styleUrls: ['./exchange-investment.component.scss']
})
export class ExchangeInvestmentComponent {
   tokens: Token[] = ['BTC', 'ETH', 'XRP'];
  exchanges: Exchange[] = ['Binance', 'Coinbase', 'CoinDCX'];

  data: Record<Exchange, Record<Token, string>> = {
    Binance: { BTC: '0.05', ETH: '1.2', XRP: '300' },
    Coinbase: { BTC: '0.02', ETH: '0.8', XRP: '250' },
    CoinDCX: { BTC: '0.03', ETH: '1.0', XRP: '280' }
  };

  getData(token: Token, exchange: Exchange): string {
    return this.data[exchange][token] || '-';
  }

}
